<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.espelhoDoPonto.string001" />
      <v-divider />

     <temp  late>
        <v-row justify="space-around">
          <v-col
            cols="12"
            sm="8"
            md="6"
          >
            <v-skeleton-loader
              :loading="loadingPeriodos"
              transition="scale-transition"
              height="80"
              :types="{ skeleton: 'list-item' }"
              type="skeleton"
            >
              <v-slide-group show-arrows>
                <v-chip-group
                  mandatory
                  active-class="white--text primary "
                  v-model="filterPeriod"
                >
                  <v-chip
                    v-for="option in filterOptions"
                    :key="option.descricao"
                    @click="aplicaFiltroPorPeriodo(option)"
                  >
                    {{ option.descricao }}
                  </v-chip>
                </v-chip-group>
              </v-slide-group>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </temp>

      <template v-if="!showError">
        <v-row justify="center">
          <v-col
            cols="12"
            lg="3"
            md="6"
          >
            <v-skeleton-loader
              :loading="loading"
              transition="scale-transition"
              max-width="344"
              :types="{ skeleton: 'card' }"
              type="skeleton"
            >
              <v-card
                class="mx-auto"
                max-width="344"
              >
                <v-card-text>
                  <p class="display-1 text--primary">
                    {{ locale[local].screen.espelhoDoPonto.string002 }}
                    {{ referenciaPeriodoSelecionado }}
                  </p>

                  <div class="text--primary">
                    {{ locale[local].screen.espelhoDoPonto.string003 }}
                    <b> {{ locale[local].screen.espelhoDoPonto.string004 }} </b> {{ locale[local].screen.espelhoDoPonto.string005 }}
                  </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="primary"
                        class="ma-2 white--text"
                        :href="
                          'data:application/octet-stream;base64,' +
                            getBase64PDF()
                        "
                        download="comprovante.pdf"
                        :disabled="showError || loading"
                        width="200"
                        max-width="200"
                      >
                        <span>
                          {{ locale[local].screen.espelhoDoPonto.string006 }}
                        </span>
                        <v-icon
                          right
                          medium
                        >
                          mdi-printer
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ locale[local].screen.espelhoDoPonto.string007 }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </template>

      <template v-if="showError">
        <v-row justify="space-around">
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-card
              class="mx-auto"
              max-width="344"
            >
              <v-card-text>
                <p class="headline text--primary">
                  Erro:
                </p>

                <div class="subtitle-1 text--primary">
                  {{ errorMessage }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-content>
  </v-app>
</template>

<script>
import moment from "moment";
import Service from "@/components/api/Service";

export default {
  data() {
    return {
      service: new Service(),
      showError: false,
      errorMessage: "",

      drawer: null,
      show: false,
      typeReceipt: 0,
      filterPeriod: 0,
      filterOptions: [
       
      ],

      receiptBase64PDF: "",
      referenciaPeriodoSelecionado: "",

      //Loadings
      loading: false,
      loadingPeriodos: false,
    };
  },
  created() {
    moment.locale("pt-br");
    this.buscaPeriodosEspelhoPonto()

  },
  methods: {
    replace(val) {
      if (val === 0) {
        return "00:00";
      }
      const [hora, minuto] = val.toString().split(".");

      if (parseInt(hora) === 0) {
        return `00:${minuto}`;
      }

      if (parseInt(minuto) === 0) {
        return `${hora}:00`;
      }

      if (!minuto) {
        return `${hora}:00`;
      }
      return `${hora}:${minuto}`;
    },
    moment: function () {
      return moment();
    },

    async buscaPeriodosEspelhoPonto() {
      
      try {

        var resposta = await this.service.getPeriodosEspelhoPonto()

        if (resposta.status === 200) {
          if (resposta.data.retorno) {
            if (resposta.data.retorno[0].estatus === "Erro") {
              this.showError = true
              this.setErrorMessage(resposta.data.retorno[0].msgErro)
              throw new Error(resposta.data.retorno[0].msgErro);
            }
          }

          var periodos = resposta.data.ttPeriodo;

          periodos.sort(function (a, b) {
            if (a.dtCompetencia < b.dtCompetencia) {
              return -1;
            }
            if (a.dtCompetencia > b.dtCompetencia) {
              return 1;
            }
            return 0;
          });

          periodos.reverse();

          // Necessária essa validação pois a API não valida se o mês atual possui comprovante gerado.
          if (periodos.length > 0) {

            var response = await this.service.getPeriodosEspelhoPonto({
              codPessoa: parseInt(localStorage.getItem("codPessoa")),
            });

            if (response.status === 200) {
              if (response.data.retorno) {
                if (response.data.retorno[0].estatus === "Erro") {
                  //periodos.shift();
                }
              }
            }
          } 
          this.popularFiltros(periodos);
          this.loadingPeriodos = false;
        } else {
          throw new Error();     
        }
      }
      catch (e) {
        this.loadingPeriodos = false;
        console.log(e);
      }
      this.filterPeriod = 0;
      var filtroSelecionado = this.filterOptions[0];
      this.aplicaFiltroPorPeriodo(filtroSelecionado);
    },
    async aplicaFiltroPorPeriodo(filtroSelecionado) {
      this.referenciaPeriodoSelecionado = filtroSelecionado.descricao; 
      this.getReceipt(filtroSelecionado.codPeriodo);
    },

    async getReceipt(codPeriodo) {
      try {
        this.cleanErrorMessage();

        this.loading = true;

        var response = await this.service.getCartaoPonto(codPeriodo);
        
        if (response.status === 200) {
          if (response.data.retorno) {
            if (response.data.retorno[0].estatus === "Erro") {
              throw new Error(response.data.retorno[0].msgErro);
            }
          } 
          this.receiptBase64PDF = response.data.ttCartao[0].anexo;
          this.loading = false;
        } else {
          throw new Error();
        }
      } catch (e) {      
          this.loading = false;
          this.setErrorMessage(e.message);       
      }
    },
    setErrorMessage(errorMessage) {
      this.showError = true;
      this.errorMessage = errorMessage;
    },
    cleanErrorMessage() {
      this.showError = false;
      this.errorMessage = "";
    },
    popularFiltros(periodos) {
      this.filterOptions = [];

      periodos.forEach((element) => {
        let periodo = moment(element.dtCompetencia);

        this.filterOptions.push({
          mes: periodo.format("M"),
          ano: periodo.format("YYYY"),
          descricao: periodo.format("MMM") + "/" + periodo.format("YYYY"),
          codPeriodo: element.codPeriodo
        });
      });
    },
    getBase64PDF() {
      return this.receiptBase64PDF;
    },
  },
};
</script>

<style scoped>
.text-dados-titulo {
  font-size: 1.5em;
  font-weight: bold;
}

.text-dados-sub-titulo {
  font-size: 1.2em;
  font-weight: bold;
}

.text-filters {
  font-size: 0.9em;
  font-weight: bold;
}

.proventos {
  color: green;
}

.descontos {
  color: red;
}

.liquido {
  color: blue;
}

.text-dados {
  font-size: 1.2em;
}
</style>
